/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IRepoUploadInitMutationVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  numParts: Types.Scalars['Int']['input'];
  filename: Types.Scalars['String']['input'];
  repoName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  assetId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type IRepoUploadInitMutation = {
  __typename?: 'Mutation';
  repoUploadInit?: {
    __typename?: 'RepoUploadInitPayload';
    success: boolean;
    errors?: Array<string> | null;
    uploadId?: string | null;
    uploadUrls?: Array<string> | null;
  } | null;
};

export const RepoUploadInitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'repoUploadInit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'numParts' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'repoName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repoUploadInit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'numParts' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'numParts' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filename' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'repoName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'repoName' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assetId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadUrls' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IRepoUploadInitMutation, IRepoUploadInitMutationVariables>;
